var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ContainerFill",attrs:{"fill-height":"","fluid":_vm.fullWidth}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }